var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('create-goal-form',{on:{"on-submit":_vm.onCreateGoalSubmit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }